import { getButtonVariantStyles } from './utils/getButtonVariantStyles.util';
import styled from 'styled-components';
import {
  type ButtonProps,
  type ClickPosition,
  ButtonVariantsEnum,
} from './Button.types';
import { radialEffect } from './animations/radialEffect';
import { size } from './variants/size';

export const StyledButton = styled.button<ClickPosition & ButtonProps>`
  border: none;
  border-radius: ${({ theme }) => `${theme.shape.button.borderRadius}`};
  cursor: pointer;
  font-family: ${(p) => p.theme.typography.fontFamily};
  ${(p) => p.blockMode && 'width: 100%;'};
  ${(p) =>
    getButtonVariantStyles(p)[p.typeStyle || ButtonVariantsEnum.Primary]};
  overflow: hidden;
  ${(p) => size[p.size ?? 'regular']}

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    ${(p) =>
      p.typeStyle === ButtonVariantsEnum.Outlined &&
      `background-color: ${p.theme.palette.button.background.outline.hover};`};
    opacity: 0.8;
    outline: 0;
  }

  ${(p) => p.sticky && 'border-radius: 0.5rem 0.5rem 0 0;'}

  ${(p) =>
    p.disabled &&
    `
      cursor: not-allowed;
      opacity: 0.39;
      pointer-events: none;

      &:hover {
        opacity: 0.39;
      }
    `}

  ${(p) => p.noMinWidth && 'min-width: 0;'}

  position: relative;
  text-align: center;
  will-change: background-color, background-position;

  ${(p) =>
    !(
      p.theme.palette.brand.linear_gradient &&
      p.typeStyle === ButtonVariantsEnum.Secondary
    ) && radialEffect.default(p)};
`;

export const StyledLoaderWrapper = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0 1rem;

  & > svg {
    display: inline-block;
    margin: unset !important;
    padding-right: 0.5rem;
  }
`;
